/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_CrossfitInputs */

const en_service_type_crossfit = /** @type {(inputs: Service_Type_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit`)
};

const pl_service_type_crossfit = /** @type {(inputs: Service_Type_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit`)
};

/**
* | output |
* | --- |
* | "CrossFit" |
*
* @param {Service_Type_CrossfitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_crossfit = /** @type {((inputs?: Service_Type_CrossfitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_CrossfitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_crossfit(inputs)
	return en_service_type_crossfit(inputs)
});